import SectionHeader from "../../components/ui/labels/SectionHeader";
import Form from "../../components/ui/input/Form";
import Dropdown from "../../components/ui/dropdowns/Dropdown";
import useCollectorADGroups from "./useCollectorADGroups";
import TextInput from "../../components/ui/input/TextInput";
import Button from "../../components/ui/buttons/Button";
import FullScreenActivityIndicator from "../../components/ui/activityIndicator/FullScreenActivityIndicator";
import InfoPrompt from "../../components/ui/prompts/InfoPrompt";
import DevModeLabel from "../../components/ui/labels/DevModeLabel";

const EditUser = () => {
  const {
    adGroupSelectHandler,
    convertADGroupHandler,
    convertMemberHandler,
    emailChangeHandler,
    memberSelectHandler,
    submitHandler,
    clearStatus,
    state,
  } = useCollectorADGroups();

  return (
    <>
      <SectionHeader text={"AD Groups"} />
      <DevModeLabel />
      <Form>
        <Dropdown
          identifier="collectorADGroup"
          title="Collector Group"
          url={`${process.env.REACT_APP_API_URL}/ad/collectorGroups`}
          fetchingMessage="Fetching Collector AD Groups..."
          noOptionsMessage="No Collector AD Groups found."
          value={state.selectedADGroup}
          selectHandler={adGroupSelectHandler}
          convertOptionsHandler={convertADGroupHandler}
        />
        {state?.selectedADGroup?.value && (
          <Dropdown
            identifier="collectorADGroupMembers"
            title="Member"
            url={`${process.env.REACT_APP_API_URL}/ad/collectorGroupMembers`}
            fetchingMessage="Fetching Members..."
            noOptionsMessage="No members found."
            value={state.selectedGroupMember}
            selectHandler={memberSelectHandler}
            convertOptionsHandler={convertMemberHandler}
            bodyObject={{ groupName: state.selectedADGroup.value }}
            dependencies={[state.selectedADGroup]}
          />
        )}
        {state?.selectedGroupMember?.value === state.newMember && (
          <TextInput
            identifier="email"
            label="Email"
            onChange={emailChangeHandler}
            value={state.email}
            type="text"
            autocomplete="email"
            error={state.emailError}
            errorText={"Invalid email."}
          />
        )}
        {state?.selectedGroupMember?.value !== "" && (
          <SectionHeader
            text={`Request user to be ${
              state.selectedGroupMember.value === state.newMember
                ? "added"
                : "removed"
            }.`}
          ></SectionHeader>
        )}
        <Button
          disabled={!state.formValid}
          onClick={submitHandler}
          text="Submit Ticket"
        />
      </Form>
      <FullScreenActivityIndicator
        loading={state.loading}
        text="Submitting Request..."
      />
      <InfoPrompt text={state.status} statusCleared={clearStatus} />
    </>
  );
};

export default EditUser;
